module.exports = __webpack_public_path__ + "static/media/page-last.3092c825.svg";